import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Initialize ScrollTrigger
gsap.registerPlugin(ScrollTrigger);


const calculateXHistory = () => {
    const itemWidth = $('.historie__wrapper').width()
    const itemCount = $('.historie__wrapper').length - 1;
    const deviceWidth = $(document).width();
    let additionalWidth = 0;

    if(window.innerWidth < 1200) {
        additionalWidth = 1200 - deviceWidth
    }

    const x = (itemWidth * itemCount) + additionalWidth

    return  '-' + x;
}

const initTimeline = () => {
    if ($('.module--historie').length && $(window).width() > 1200) {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: '.module--historie',
                pin: true,
                scrub: 1,
                start: 'top top',
                end: "+=1000%",
                invalidateOnRefresh: true,
            },
        });
        timeline.to('.historie__wrapper', {
            x: calculateXHistory(),
        });
    }
}

initTimeline();

// Voer de functie opnieuw uit wanneer het venster wordt aangepast
window.addEventListener('resize', () => {
    console.log('resize')
    initTimeline();
});
